import React from 'react';
import { Link } from 'react-router-dom';
import { formatLogTime } from '../../utils/todayStats';

export default function ActivityLog({ events }) {
  return (
    <div className="today-panel today-panel-log">
      <div className="today-panel-header">
        <span className="today-panel-title">The log</span>
      </div>
      <div className="today-log-body">
        {events.length === 0 ? (
          <div className="today-empty">No recent activity yet.</div>
        ) : (
          events.map((event) => (
            <div key={event.id} className="today-log-line">
              <span className="today-log-time">{formatLogTime(event.at)}</span>
              <span className="today-log-text">{event.line}</span>
            </div>
          ))
        )}
      </div>
      <div className="today-panel-footer">
        <Link to="/leads" className="today-link-accent">OPEN INBOX →</Link>
      </div>
    </div>
  );
}
